import { isFunction } from '../is-function';
import { isReactClass } from '../is-react';
export function isDynamicSetter(obj) {
  if (!isFunction(obj)) {
    return false;
  }
  return !isReactClass(obj);
}